<template>
  <div v-if="category || seat">
    <template v-if="category">
      <div :class="color">{{ category }}</div>
    </template>
    <template v-if="seat">
      <div>{{ seat }}</div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  category: {
    type: String,
    required: false,
  },
  seat: {
    type: String,
    required: false,
  },
  theme: {
    type: String,
    required: false,
  },
});

const color = computed(() => ({
  default: 'text-blue-500',
  pga:     'text-pga-500',
  pgb:     'text-pgb-500',
  pgc:     'text-pgc-500',
  pgd:     'text-pgd-500',
}[props.theme ?? 'default']));

</script>
